import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '../Typography';
import { OutOfPocketMax } from '../../types';
import './InsuranceVerificationDetails.scss';

type props = {
  outOfPocketExpense: OutOfPocketMax;
  className?: string;
};

export const InsuranceOutOfPocketExpense: React.FC<props> = ({
  outOfPocketExpense,
  className,
}: props) => {
  const { t } = useTranslation('insuranceVerification');

  return (
    <div className={`card-container ${className || ''}`}>
      <Typography variant="size-18" color="color-2">
        {t('insuranceOutOfPocketExpense.title')}
      </Typography>

      <div className="row">
        <div className="col d-flex flex-column justify-content-between">
          <Typography
            variant="size-10"
            weight="bold"
            color="color-28"
            className="mt-3"
            textTransform="uppercase"
          >
            {t('insuranceOutOfPocketExpense.maxOutOfPocketExpenseLabel')}
          </Typography>

          <Typography
            variant="size-26"
            weight="bold"
            color="color-2"
            className="mt-1"
          >
            {outOfPocketExpense.plan_oop_max}
          </Typography>
        </div>

        <div className="col d-flex flex-column justify-content-between">
          <Typography
            variant="size-10"
            weight="bold"
            color="color-28"
            className="mt-3"
            textTransform="uppercase"
          >
            {t(
              'insuranceOutOfPocketExpense.maxAmountAppliedOutOfPocketExpenseLabel',
            )}
          </Typography>

          <Typography
            variant="size-26"
            weight="bold"
            color="color-2"
            className="mt-1"
          >
            {outOfPocketExpense.amount_applied_to_oop_max}
          </Typography>
        </div>
      </div>

      <Typography variant="size-14" color="color-28" className="mt-2">
        {t('insuranceOutOfPocketExpense.description')}
      </Typography>
    </div>
  );
};
